// extracted by mini-css-extract-plugin
module.exports = {"Selected":"Navbar_Selected__1F1ya","Deselected":"Navbar_Deselected__3YHtI","Wrapper":"Navbar_Wrapper__2Oi54"};